// @flow
import BluebirdPromise from 'bluebird';

import * as r from './resources';
import { post } from './http';

import type { SerializedReportOrders } from 'modules/report-orders';
import type { Dispatch, GetState } from '~/store';

export const reportOrders = (
  params: SerializedReportOrders,
): ((dispatch: Dispatch, getState: GetState) => BluebirdPromise<mixed>) =>
  post(r.reportOrders, '', params);
